import { ApolloError } from '@apollo/client';

import { useGroupDetailQuery, GroupDetailQuery } from 'core/graphql';

import { useStableRefetch } from './useStableRefetch';

export type IGroupDetail = NonNullable<GroupDetailQuery['group']>;

interface IGroupDetailHook {
  group?: IGroupDetail;
  loading: boolean;
  error?: ApolloError;
  refetch: () => void;
}

/** Backs `/groups/:id/details` — `group(groupId)` resolver, minimal fields. */
export const useGroupDetail = (id?: string): IGroupDetailHook => {
  const { data, loading, error, refetch } = useGroupDetailQuery({
    variables: { id: id || '' },
    skip: !id,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  return {
    group: data?.group ?? undefined,
    loading,
    error,
    refetch: useStableRefetch(refetch),
  };
};
